var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNz(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 40,
    fill: "none",
    viewBox: "0 0 54 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00247d",
    fillRule: "evenodd",
    d: "M.7 0H54v40H.7z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M41.5 9v1.2l2.6-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m42 10.4-.5-1 2.6-.5zM41.5 9v1.2L39 8.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m41 10.4.5-1L39 9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m42.3 9.5-1.2.3 2 2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m41 10.4.8-.8L43 12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m40.8 9.5 1.2.3-.4-2.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m42.4 9.4-1.1.2.3-2.5zm-1.6.1 1.2.3-2 2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m42.1 10.4-.8-.8L40 12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cc142b",
    d: "M41.5 9.2v.8l1.7-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cc142b",
    d: "m41.9 10.2-.4-.7 1.7-.3zm-.4-1v.8L40 9.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cc142b",
    d: "m41.2 10.2.3-.7-1.6-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cc142b",
    d: "m42 9.5-.8.3 1.3 1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cc142b",
    d: "m41.2 10.2.5-.6.8 1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cc142b",
    d: "m41 9.5.9.3-.3-1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cc142b",
    d: "m42.1 9.5-.7.1.2-1.7zm-1.1 0 .9.3-1.4 1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cc142b",
    d: "m42 10.2-.6-.6-.9 1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M48.2 14.8v1l2.2-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m48.6 16.1-.4-.9 2.2-.4zm-.4-1.3v1l-2.3-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m47.7 16.1.5-.9-2.3-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m48.8 15.2-1 .4 1.7 1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m47.7 16 .7-.6 1.1 2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m47.5 15.2 1 .4-.3-2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m49 15.2-1 .2.2-2.3zm-1.5 0 1 .4-1.7 1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m48.7 16-.8-.6-1 2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cc142b",
    d: "M48.2 15v.7l1.4-.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cc142b",
    d: "m48.4 15.9-.2-.6 1.4-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cc142b",
    d: "M48.2 15v.7l-1.4-.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cc142b",
    d: "m47.9 15.9.3-.6-1.4-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cc142b",
    d: "m48.6 15.3-.7.2 1 1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cc142b",
    d: "m47.8 15.8.5-.4.7 1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cc142b",
    d: "m47.8 15.3.6.2-.2-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cc142b",
    d: "m48.6 15.3-.6.1.2-1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cc142b",
    d: "m47.8 15.3.6.2-1 1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cc142b",
    d: "m48.5 15.8-.5-.4-.7 1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M33.8 16.7V18l2.5-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m34.3 18.2-.5-1 2.5-.5zm-.5-1.5V18l-2.5-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m33.3 18.2.5-1-2.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m34.5 17.2-1.2.4 2 2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m33.3 18.2.8-.8 1.2 2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m33.1 17.2 1.2.4-.4-2.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m34.7 17.2-1.1.2.3-2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m33.1 17.2 1.2.4-2 2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m34.4 18.2-.8-.8-1.3 2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cc142b",
    d: "M33.8 17v.8l1.7-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cc142b",
    d: "m34.2 18-.4-.7 1.7-.3zm-.4-1v.8l-1.7-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cc142b",
    d: "m33.5 18 .3-.7-1.7-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cc142b",
    d: "m34.3 17.3-.8.3 1.3 1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cc142b",
    d: "m33.4 18 .6-.6.8 1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cc142b",
    d: "m33.3 17.3.8.3-.2-1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cc142b",
    d: "m34.4 17.3-.7.1.2-1.7zm-1.1 0 .8.3-1.3 1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cc142b",
    d: "m34.2 18-.5-.6-.9 1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M41.5 28.9v1.4l2.8-1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m42.1 30.6-.6-1.1 2.8-.6zm-.6-1.7v1.4l-2.8-1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m41 30.6.5-1.1-2.8-.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m42.3 29.5-1.3.4 2.2 2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m41 30.5.8-.8 1.4 2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m40.7 29.5 1.4.4-.5-3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m42.5 29.5-1.2.2.3-2.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m40.7 29.5 1.4.4-2.2 2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m42.2 30.5-1-.8L40 32z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cc142b",
    d: "M41.5 29.2v1l2-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cc142b",
    d: "m42 30.3-.5-.8 2-.3zm-.5-1.1v1l-2-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cc142b",
    d: "m41.1 30.3.4-.8-2-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cc142b",
    d: "m42 29.6-.8.3 1.5 1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cc142b",
    d: "m41.1 30.3.6-.6 1 1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cc142b",
    d: "m41 29.6 1 .3-.4-2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cc142b",
    d: "m42.2 29.5-.8.2.2-2zm-1.2.1 1 .3-1.6 1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cc142b",
    d: "m42 30.3-.6-.6-1 1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#012169",
    d: "M.7 0h26.6v20H.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M3.8 0 14 7.5 24 0h3.3v2.6l-10 7.4 10 7.5V20H24l-10-7.5L4 20H.7v-2.5l10-7.4-10-7.4V0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8102e",
    d: "m18.3 11.7 9 6.6V20L16 11.7zm-7.6.8.2 1.5-8 6H.7zM27.3 0v.1L17 8V6l8.3-6zM.7 0l10 7.3H8L.7 1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10.7 0v20h6.7V0zM.7 6.7v6.6h26.6V6.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8102e",
    d: "M.7 8v4h26.6V8zM12 0v20h4V0z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.7 0H54v40H.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNz);
export default __webpack_public_path__ + "static/media/nz.b83188fe939ef4ea70ac3c0838f8fc70.svg";
export { ForwardRef as ReactComponent };